import React from 'react';
import { Scale } from 'lucide-react';
import FormModalLayout from '../Common/FormModalLayout';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const ProfessionalCouncilModal = ({ council, onSubmit, onClose }) => {
  const [formData, setFormData] = React.useState({
    name: council?.name || '',
    acronym: council?.acronym || '',
    region: council?.region || 'AL',
    status: council?.is_active === false ? 'INACTIVE' : council?.status || 'ACTIVE',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <FormModalLayout
      title={council ? 'Editar conselho profissional' : 'Novo conselho profissional'}
      subtitle="Conselhos de classe (CREA, CRM, etc.) usados no cadastro de profissionais."
      headerIcon={Scale}
      onClose={onClose}
      size="md"
      historyEntityType="professional_councils"
      historyEntityId={council?.id}
      footer={
        <>
          <button type="button" onClick={onClose} className="btn btn-outline">
            Cancelar
          </button>
          <Can permission={P.PROFESSIONAL_ACCESS}>
            <button type="submit" form="pro-council-modal-form" className="btn btn-primary">
              {council ? 'Atualizar' : 'Criar'}
            </button>
          </Can>
        </>
      }
    >
      <form id="pro-council-modal-form" onSubmit={handleSubmit} className="form-stack">
        <div className="form-group">
          <label htmlFor="pc-name" className="form-label form-label-required">
            Nome
          </label>
          <input
            id="pc-name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="pc-acronym" className="form-label form-label-required">
            Sigla
          </label>
          <input
            id="pc-acronym"
            type="text"
            name="acronym"
            value={formData.acronym}
            onChange={handleChange}
            className="form-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="pc-region" className="form-label form-label-required">
            Região / UF
          </label>
          <input
            id="pc-region"
            type="text"
            name="region"
            value={formData.region}
            onChange={handleChange}
            className="form-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="pc-status" className="form-label">
            Status
          </label>
          <select
            id="pc-status"
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="form-select"
          >
            <option value="ACTIVE">Ativo</option>
            <option value="INACTIVE">Inativo</option>
          </select>
        </div>
      </form>
    </FormModalLayout>
  );
};

export default ProfessionalCouncilModal;
